import { Component, OnInit } from '@angular/core';
import { ConfigsDeadlineInvoiceComponent } from '../configs-deadlineinvoice/configs-deadline-invoice.component';
import { ConfigsCategoriesComponent } from '../configs-categories/configs-categories.component';
import { ConfigsDeadlineModalComponent } from '../configs-modals/deadline-modal/configs-deadline-modal.component';
import { ConfigsInvestorDocumentsComponent } from '../configs-investor-documents/configs-investor-documents.component';
import { Config } from './../../../../../_models';

@Component({
    selector: 'app-configs',
    templateUrl: './configs-list.component.html',
    styles: []
})
export class ConfigsListComponent implements OnInit {
    public currentUser: any = JSON.parse(localStorage.getItem('currentUser'));
    data: Config = new Config(null, null, null, null, null, null, null);
    constructor() { }

    ngOnInit() {
    }

}



// WEBPACK FOOTER //
// /Users/cmedina/Code/motto_frontend/src/app/theme/pages/aside-left-display-disabled/configs/configs-list/configs-list.component.ts